import React from 'react';
import { faUnlink } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './PartialIcon.scss';

const PartialIcon = (props) => (
    <FontAwesomeIcon className='pi-rotation' icon={faUnlink} />);

export default PartialIcon;
